import React, { ReactElement } from 'react';
import styled from '@emotion/styled';

import GalleryModal from './GalleryModal';
import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll';
import PrimaryButton from '../../atoms/buttons/PrimaryButton';
import { PhotoConfig } from '../../config/Media';
import breakpoints from '../../theme/material/breakpoints';
import { CustomStyledProps } from 'style/style';
import colors from 'theme/colors';
import { isDarkMode } from 'utils/helpers';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ModalHeader = styled('h3')(() => ({
  marginTop: 30,
  fontWeight: 700,
  fontSize: 22,
  lineHeight: '27px',
  color: '#E21D4A',
  letterSpacing: -0.3,
  marginBottom: 8,
  [breakpoints.down(639.05)]: {
    lineHeight: '28px',
    maxWidth: 310,
    textAlign: 'center',
    marginBottom: 10,
    fontSize: 25,
  },
}));

const ModalSubheader = styled('p')(() => ({
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '19px',
  letterSpacing: '-0.3px',
  color: isDarkMode() ? '#AFB0B1' : '#595959',
  margin: 0,
  marginBottom: 15,
}));

const ModalDescription = styled('div')(
  {
    paddingBottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    maxWidth: 350,
    margin: 'auto',
  },
  ({ hasHeader }: CustomStyledProps) => !hasHeader && { marginTop: 0 }
);

const AgreementList = styled('ul')({
  padding: 0,
  width: '100%',
  paddingLeft: 20,
  margin: 'auto',
  marginBottom: 25,
  maxWidth: 252,
});

const StyleList = styled('li')({
  padding: '5px 0',
  fontSize: 14,
  lineHeight: '19px',
});

const StyleStrong = styled('strong')({
  fontWeight: 700,
});
const RedStyle = styled('span')({
  fontWeight: 700,
  color: colors.light.red.primary,
});

const UploadJoinFlowContentModal = (props: any): ReactElement => {
  const { onClose, onConfirm, ...rest } = props;

  useDisableBodyScroll(props.isOpen);

  return (
    <GalleryModal
      onClose={onClose}
      customStyle={{ content: { maxWidth: 450 } }}
      {...rest}
      contentLabel=""
      customContentStyle={{ padding: 20 }}
      customCloseBtnStyle={{ top: 8, right: 8 }}
    >
      <ModalDescription hasHeader={true} data-test-id="gallery-agreement">
        <ModalHeader>Upload Gallery Content</ModalHeader>
        <ModalSubheader>Show off with up to 20 photos</ModalSubheader>
        <AgreementList>
          <StyleList>
            <StyleStrong>All photos will be moderated for content</StyleStrong>
          </StyleList>
          <StyleList>
            <RedStyle>
              For selfie verification, please include at least one photo showing your face (can be set to private)
            </RedStyle>
          </StyleList>
          <StyleList>
            Recommended width: <StyleStrong>400+ px wide portrait</StyleStrong>{' '}
          </StyleList>

          <StyleList>
            Max file size: <StyleStrong>15 Mb</StyleStrong>
          </StyleList>
          <StyleList>
            Max photos allowed: <StyleStrong>20</StyleStrong>
          </StyleList>
          <StyleList>
            Accepted image formats: <br />
            <StyleStrong>{PhotoConfig.allowedMimeTypeText}</StyleStrong>
          </StyleList>
        </AgreementList>

        <PrimaryButton
          customStyle={{
            width: 'inherit',
            fontSize: 14,
            fontWeight: 600,
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 22,
            paddingRight: 22,
            marginBottom: 20,
            height: 40,
          }}
          data-test-id={`gallery-upload-content-type`}
          onClick={() => {
            onConfirm(false);
          }}
          color="red"
          label="Select Photo(s)"
        />
      </ModalDescription>
    </GalleryModal>
  );
};

export default UploadJoinFlowContentModal;
